module.exports = __webpack_public_path__ + "ap.no1.df46e5f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ap.no1.jpg
// module id = XZth
// module chunks = 0